// Third-party Imports
import { configureStore } from '@reduxjs/toolkit'

// Slice Imports
import authenticaSuccess from '@/redux-store/slices/authenticaSuccess'
import userReducer from '@/redux-store/slices/user'
import forgot2FAReducer from '@/redux-store/slices/forgot2fa'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

export const store = configureStore({
  reducer: {
    authenticaSuccess,
    userReducer,
    forgot2FAReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
